module.exports = __webpack_public_path__ + "img/avatar.8597df0b.png";